
import { propsInstance } from "@/lib/util";
import { Component, MixedVue, mixins } from "@/vue";

const Props = propsInstance<{
  progress?: number;
  showLoadingMessage?: boolean;
  showCancelMessage?: boolean;
  size?: number;
  color?: string;
}>({
  progress: {
    type: Number,
    required: false,
    default: null,
  },
  showLoadingMessage: {
    type: Boolean,
    required: false,
    default: false,
  },
  showCancelMessage: {
    type: Boolean,
    required: false,
    default: false,
  },
  size: {
    type: Number,
    required: false,
    default: 80,
  },
  color: {
    type: String,
    required: false,
    default: "#3869ff",
  },
});

@Component({
  name: "Loading",
})
export default class Loading extends mixins(MixedVue, Props) {
  get stringSize() {
    return this.size + "px";
  }

  get outerRingStyle() {
    return {
      width: this.stringSize,
      height: this.stringSize,
    };
  }

  get ringStyle() {
    return {
      border: this.size / 8 + "px solid",
      borderColor: this.color + " transparent transparent transparent",
    };
  }
}
